import {useEffect} from 'react'
import Swal from 'sweetalert2'
import {PageOverlayer} from '../../../../../components/PageOverlayer'
import {Header} from './Header'
import {useForm} from '../core/FormProvider'
import {formatMask} from '../../../../../utils/formatMonetaryToBr'

const Metric = () => {
  const {loading, setLoading, saleSummary, filterDates, getDataSaleSummary} = useForm()

  useEffect(() => {
    const summary = async () => {
      setLoading(true)
      try {
        await getDataSaleSummary('', '')
      } catch (error: any) {
        Swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: error?.response?.data?.message,
          showConfirmButton: true,
          customClass: {
            confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
            cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
          },
        })
      } finally {
        setLoading(false)
      }
    }

    summary()
  }, [])

  return (
    <>
      <Header />
      {loading ? (
        <PageOverlayer />
      ) : (
        <div className='row m-5'>
          <table className='table table-rounded table-bordered border gy-7 gs-7 align-middle text-center'>
            <thead>
              <tr
                className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200 align-middle text-center'
                style={{backgroundColor: 'rgb(220, 219, 219)'}}
              >
                <th rowSpan={2}>Vendas</th>
                <th rowSpan={2}>
                  Mês Filtrado <br />
                  {saleSummary?.current_month}
                </th>
                <th colSpan={2}>Mês Anterior</th>
                <th colSpan={2}>Mês Ano Anterior</th>
              </tr>
              <tr
                className='align-middle text-center'
                style={{backgroundColor: 'rgb(220, 219, 219)'}}
              >
                <td>
                  <b>
                    Total Mês Anterior <br />
                    {saleSummary?.previous_month}
                  </b>
                </td>
                <td>
                  <b>Até dia {filterDates?.day}</b>
                </td>
                <td>
                  <b>
                    Total Mês Anterior <br />
                    {saleSummary?.previous_monthAndYear}
                  </b>
                </td>
                <td>
                  <b>Até dia {filterDates?.day}</b>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>TT:</td>
                <td>{formatMask(saleSummary?.sale_current_month)}</td>
                <td>{formatMask(saleSummary?.sale_sub_month)}</td>
                <td>{formatMask(saleSummary?.sale_sub_day_month)}</td>
                <td>{formatMask(saleSummary?.sale_sub_Year)}</td>
                <td>{formatMask(saleSummary?.sale_sub_day_year)}</td>
              </tr>
              <tr>
                <td colSpan={2}></td>
                <td colSpan={2}>
                  {saleSummary?.percentage_current_sub_Day_Month
                    ? `${saleSummary?.percentage_current_sub_Day_Month}%`
                    : ''}
                </td>
                <td colSpan={2}>
                  {saleSummary?.percentage_current_sub_day_year
                    ? `${saleSummary?.percentage_current_sub_day_year}%`
                    : ''}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}

export {Metric}
